import { Divider, Drawer, Space, Button, Radio, Checkbox } from "antd";
import React from "react";
import moment from "moment";
import ColourPicker from "../../../globals/styles/ColourPicker";
import ImageSelect from "../../ImageSelect";
import { apiCall } from "../../../utils/Api";
import { usePrefs } from "../../../utils/Prefs";
import BMInput from "../../comps/BMInput";
import { PaddingHorizontalIcon, PaddingVerticalIcon } from "../../Icons";

export default function SearchBar(props) {
    const [prefs, setPrefs] = usePrefs();
    const { edit = false, close = () => { } } = props;

    // set componenet specific
    const setData = (_data) => {
        setPrefs({ ...prefs, "search_bar": { ...prefs.search_bar, "data": _data } })
    }

    // set componenet agnostic
    const setContent = (_key, _data) => {
        setPrefs({ ...prefs, "search_bar": { ...prefs.search_bar, [_key]: _data } })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = prefs.search_bar;

    // Component specific
    const {
        background_colour = 0,
        search_bar_logo = "",
        text_colour = 0,
        text_hover_colour = 0,
        pin_navigation = true,
        logo_height = 40,
        padding_x = 0,
        padding_y = 0,
        drop_shadow = true,
    } = data;

    const save = () => {
        props.saveItem("search_bar", prefs.search_bar);
        close(); 
    }

    // Re-fetch old and update ui element
    const onCancel = () => {
        apiCall("site_content/getContent", {}, (_status, _result) => {
            if (_status) {
                if (_result) {
                    let _r = _result.find(item => item.component === "search_bar")
                    if (_r) {
                        setPrefs({ ...prefs, "search_bar": {...prefs.search_bar, "data" : _r.data, "container" : _r.container} })
                    }
                }
            }
        })
        close();
    }

    const drawForm = () => {
        return (
            <>
                <div style={{ "fontSize": "18px", "lineHeight": "18px" }}><strong>{name}</strong></div>
                {(date_changed && <em style={{ "fontSize": "12px" }}>Last updated {moment(date_changed * 1000).format("MMM Do, YYYY h:mm a")}</em>)}
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "justifyContent": "stretch" }}>
                    <Button onClick={() => save()} block size="small" type="primary"><small>Save Changes</small></Button>
                    <div style={{ "width": "10px" }}></div>
                    <Space>
                        <Button onClick={() => onCancel()} size="small" type="default"><small>Cancel</small></Button>
                    </Space>
                </div>
                <div style={{ "margin": "0px -25px" }}><Divider style={{ "margin": "15px 0px" }} /></div>
                {/* CONTAINER */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LAYOUT</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={container} onChange={(e) => setContent("container", e.target.value)} >
                            <Radio value={false}><small>100% of the screen width</small></Radio>
                            <Radio value={true}><small>Container width (max 1248px)</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                {/* DISPLAY */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">DISPLAY</Divider>
                <div className="float-flex">
                    <div></div>
                    <Space>
                        <Radio.Group value={pin_navigation} onChange={(e) => setData({ ...data, "pin_navigation": e.target.value })} >
                            <Radio value={true}><small>Always show</small></Radio>
                            <Radio value={false}><small>Hide when scrolling down</small></Radio>
                        </Radio.Group>
                    </Space>
                </div>
                <div className="shim" /><div className="shim" />
                {/* LOGO */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">SEARCH BAR LOGO</Divider>
                <ImageSelect width={235} onChange={(_v) => setData({ ...data, "search_bar_logo": _v })} path={search_bar_logo} />
                {/* LOGO PADDING */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LOGO PADDING</Divider>
                <Space>
                    <BMInput value={padding_x} onChange={(_v) => setData({ ...data, "padding_x": _v })} number min={0} max={100} prefix={<PaddingHorizontalIcon style={{"color" : "#888"}} />} />
                    <BMInput value={padding_y} onChange={(_v) => setData({ ...data, "padding_y": _v })} number min={0} max={100} prefix={<PaddingVerticalIcon style={{"color" : "#888"}} />} />
                </Space>
                <div className="shim" /><div className="shim" />
                {/* MAX LOGO HEIGHT */}
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">LOGO HEIGHT</Divider>
                <BMInput value={logo_height} onChange={(_v) => setData({ ...data, "logo_height": _v })} number min={40} max={80} prefix="HEIGHT" />
                <div className="shim" /><div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">BACKGROUND COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={background_colour} onChange={(e) => setData({ ...data, "background_colour": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT / BUTTON COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={text_colour} onChange={(e) => setData({ ...data, "text_colour": e })} />
                <div className="shim" /> <div className="shim" />
                <Divider orientationMargin={0} orientation="left" plain className="simple-divider">TEXT / BUTTON HOVER COLOUR</Divider>
                <ColourPicker allow_none allow_gradient value={text_hover_colour} onChange={(e) => setData({ ...data, "text_hover_colour": e })} />
                <div className="shim" /> <div className="shim" />
                <div className="float-flex">
                    <Checkbox checked={drop_shadow} onChange={(e) => setData({ ...data, "drop_shadow": e.target.checked })}><small>Drop shadow?</small></Checkbox>
                </div>
            </>
        )
    }
    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX" : "hidden" }} closable={false} width={300} onClose={() => onCancel(true)} open={edit}>
                {drawForm()}
                <pre><small>{JSON.stringify(props.record, null, 2)}</small></pre>
            </Drawer>
        </>
    )
}